/* ARIELLE v48 — accessible mobile category-carousel controls. */
(function(){
  function setup(section){
    var track=section.querySelector('[data-ar48-track]');
    var prev=section.querySelector('[data-ar48-prev]');
    var next=section.querySelector('[data-ar48-next]');
    if(!track||!prev||!next)return;
    function update(){
      var max=Math.max(0,track.scrollWidth-track.clientWidth);
      prev.disabled=track.scrollLeft<=5;
      next.disabled=track.scrollLeft>=max-5;
    }
    function move(dir){
      var card=track.querySelector('.ar48-worlds__card');
      var gap=parseFloat(getComputedStyle(track).gap)||12;
      var step=card?card.getBoundingClientRect().width+gap:track.clientWidth*.8;
      track.scrollBy({left:dir*step,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    }
    prev.addEventListener('click',function(){move(-1)});
    next.addEventListener('click',function(){move(1)});
    track.addEventListener('scroll',update,{passive:true});
    window.addEventListener('resize',update,{passive:true});
    update();
  }
  document.querySelectorAll('.ar48-worlds').forEach(setup);
})();